import React from 'react';
import iconOk from '@frontend/jetlend-assets/icons/icon--ok.svg';
import iconOkV2 from '@frontend/jetlend-assets/icons/icon--ok-v2.svg';
import iconError from '@frontend/jetlend-assets/icons/icon--stop.svg';
import iconBanCircle from '@frontend/jetlend-assets/icons/icon--ban-circle.svg';
import styles from './ProgressCaption.module.scss';
import Loader from '../loaders/Loader';
import { buildClassNames } from '../../utils/classNameUtils';
import { getAssetSrc } from '@ui/utils/getAssetSrc';

export interface IProps {
    title: string;
    completed?: boolean;
    loading?: boolean;
    extraMarginBottom?: boolean;
    shrink?: boolean;
    iconsType?: IconsType;
    bordered?: boolean;
}

type IconsType = 1 | 2

export default function ProgressCaption({
    title,
    completed,
    loading,
    extraMarginBottom = false,
    shrink,
    iconsType = 1,
    bordered,
}: IProps) {

    const loaderClassNames = buildClassNames(styles, ['loader-wrapper', bordered && 'bordered']);

    const YellowLoader: React.FC = () => (
        <div className={loaderClassNames}>
            <Loader size="small" spinnerType="three-sides-circle" inverted />
        </div>
    );


    const captionClassNames = buildClassNames(styles, [
        'caption',
        extraMarginBottom && 'caption--extra-margin-bottom',
        shrink && 'caption--shrink',
        bordered && 'bordered',
    ]);

    const iconClassNames = buildClassNames(styles, [
        'caption__icon',
        !completed && !loading && 'caption__icon--ban',
        bordered && 'bordered',
    ]);

    const titleClassNames = buildClassNames(styles, ['caption__title', bordered && 'bordered']);

    const icon = {
        success: iconsType === 1 ? iconOk : iconOkV2,
        error: iconsType === 1 ? iconError : iconBanCircle,
        // TODO Refactor later
        // eslint-disable-next-line no-nested-ternary
        loading: iconsType === 1 ? bordered ? <Loader size="normal" spinnerType="three-sides-circle" grey /> : <Loader size="large" /> : <YellowLoader />,
    };

    return (
        <div key={title} className={captionClassNames}>
            <span className={iconClassNames}>
                {completed && !loading && <img src={getAssetSrc(icon.success)} alt="success" />}
                {!completed && !loading && <img src={getAssetSrc(icon.error)} alt="error" />}
                {loading && icon.loading}
            </span>
            <span className={titleClassNames}>{title}</span>
        </div>
    );
};
